module.exports = __webpack_public_path__ + "static/intro_info-da95dd485ac7c481a6d1b8bd37637351.png";